import React__default, { createContext, useContext } from 'react';
import { u as useIsMobile } from '../theme/MobileThemeProvider/useIsMobile-B-VP6bHU.js';

const DropdownIsMobileContext = /*#__PURE__*/createContext(false);
const DropdownIsMobileProvider = ({
  mobileFullScreen = false,
  children
}) => {
  const isMobile = useIsMobile();
  const dropdownIsMobile = mobileFullScreen && isMobile || false;
  return /*#__PURE__*/React__default.createElement(DropdownIsMobileContext.Provider, {
    value: dropdownIsMobile
  }, children);
};
const useDropdownIsMobile = () => {
  const isMobile = useContext(DropdownIsMobileContext);
  return isMobile;
};

export { DropdownIsMobileProvider as D, useDropdownIsMobile as u };
//# sourceMappingURL=DropdownIsMobileContext-DM1QP5jf.js.map
